import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import birthCountry from './birthCountry.js'

export default contract({
  birthCountry: array([
    birthCountry
  ])
})
